const state = {
    profitLossItem: null,
    viewBetsItem: null,
    plFilterOption: null
};
const getters = {
    profitLossItem: state => state?.profitLossItem,
    viewBetsItem: state => state?.viewBetsItem,    
    plFilterOption: state => state?.plFilterOption,    
};
const actions = {
    setProfitLossItem({ commit }, profitLossItem) {
        commit('setProfitLossItem', profitLossItem);
    },
    setViewBetsItem({ commit }, viewBetsItem) {
        commit('setViewBetsItem', viewBetsItem);
    },
    setPlFilterOption({ commit }, plFilterOption) {
        commit('setPlFilterOption', plFilterOption);
    },
    
};
const mutations = {
    setProfitLossItem(state, profitLossItem) {
        state.profitLossItem = profitLossItem;
    },
    setViewBetsItem(state, viewBetsItem) {
        state.viewBetsItem = viewBetsItem;
    },
    setPlFilterOption(state, plFilterOption) {
        state.plFilterOption = plFilterOption;
    },
};
export default {
    state,
    getters,
    actions,
    mutations
};